module.exports = __webpack_public_path__ + "static/flags/JA-19ef05d12a65ad6274e1054ab56ffa4b.gif";